import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';

import { PropertyContactedModel } from 'common/data/property-contacted/model';
import { PropertyContactedStoreEvent } from 'common/data/property-contacted/store.event';
import { arrayFind } from 'common/helper/array/find';
import { DataStore } from 'common/module/data/store';
import { PropertyContactedStoreServiceInterface } from 'common/service/property-contacted-store/service.interface';
import { PropertyLastContactedServiceInterface } from 'common/service/property-last-contacted/service.interface';

export class PropertyLastContactedViewStore extends DataStore implements PropertyLastContactedServiceInterface {
  /**
   * Constructor
   */
  constructor(
    eventEmitter: EventEmitterInterface,
    private propertyContactedService: PropertyContactedStoreServiceInterface
  ) {
    super(eventEmitter);

    this.observers();
  }

  /**
   * @inheritDoc
   */
  public getLastContacted(propertyId: string): PropertyContactedModel {
    return arrayFind(
      this.propertyContactedService.getAllFromCache(),
      (model) => model.property_id === parseInt(propertyId, 10)
    );
  }

  /**
   * Attach observers
   */
  private observers(): void {
    this.propertyContactedService
      .getEventEmitter()
      .addListener(PropertyContactedStoreEvent.sync, this.onSyncPropertyContactedStore);
  }

  /**
   * Sync property contacted store
   */
  private onSyncPropertyContactedStore = () => {
    // Refresh state and trigger repaint
    this.setState({});
  };
}
